module.exports = {"410305001":"湖北路街道","410305002":"天津路街道","410305003":"长春路街道","410305004":"南昌路街道","410305005":"长安路街道","410305006":"重庆路街道","410305007":"郑州路街道","410305008":"武汉路街道","410305009":"徐家营街道","410305010":"珠江路街道","410305011":"周山路街道","410305012":"工农街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410305.json
// module id = 1414
// module chunks = 0